export default __webpack_public_path__ + "static/media/Auto-Loan-Banner.7744abd5.png";